export type ChangeProjectSettings = { [settingId: string]: any }

export interface ProjectSettings {
    cc: {
        defaultApprovalLevelsAssigned: boolean
        defaultResponsesAssigned: boolean
        defaultRequirementsPriorityAssigned: boolean
        defaultRequirementsReviewMethodAssigned: boolean
        defaultRequirementsSmartComplianceAssigned: boolean
        defaultRequirementsStatusAssigned: boolean
        defaultRequirementsTypeAssigned: boolean
        defaultReviewItemTypesAssigned: boolean
        defaultLibraryAssigned: boolean
    }
    lifecycle: {
        defaultLifecyclesAssigned: boolean
    }
    sil: {
        assumption: string
    }
    rrs: {
        defaultCategoriesAssigned: boolean
        defaultTemplatesAssigned: boolean
    }
    study: {
        studyFieldsAssigned: boolean
        studyFields: {
            description: boolean
            manager: boolean
            systemStage: boolean
            studyStatus: boolean
            location: boolean
            site: boolean
            plant: boolean
            group: boolean
            unit: boolean
            subUnit: boolean
        }

        teamMembersFieldsAssigned: boolean
        teamMembersFields: {
            company: boolean
            title: boolean
            department: boolean
            competence: boolean
            phone: boolean
            email: boolean
            comments: boolean
        }

        sessionFieldsAssigned: boolean
        sessionFields: {
            facilitator: boolean
            scribe: boolean
            comment: boolean
        }
    }
}

export interface ProjectSettingsState {
    settings: ProjectSettings
}

export const SET_PROJECT_SETTINGS = "SET_PROJECT_SETTINGS"
export const UPDATE_PROJECT_SETTINGS = "UPDATE_PROJECT_SETTINGS"
